import React from 'react';
import '../css/Spinner.css';

/**
 * Spinner
 *
 * Props:
 *   size     — diameter in px (default 36 for block, 1em for inline)
 *   inline   — render a small in-flow spinner (for buttons / text rows)
 *   className
 */
const Spinner = ({ size, inline = false, className = '' }) => {
  if (inline) {
    const style = size ? { width: size, height: size } : undefined;
    return (
      <span
        className={`spinner spinner--inline ${className}`.trim()}
        style={style}
        role="status"
        aria-label="Loading"
      />
    );
  }

  const style = size ? { '--qd-spinner-size': `${size}px` } : undefined;
  return (
    <div className="spinner-container" style={style}>
      <div className="spinner" role="status" aria-label="Loading"></div>
    </div>
  );
};

export default Spinner;
